"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_1 = tslib_1.__importDefault(require("react"));
var close_button_scss_1 = tslib_1.__importDefault(require("./close-button.scss"));
var CloseTickIcon_1 = tslib_1.__importDefault(require("../../../icons/compiled/components/CloseTickIcon"));
var inline_icon_1 = tslib_1.__importDefault(require("../inline-icon/inline-icon"));
var CloseButton = function (_a) {
    var className = _a.className, ariaLabel = _a.ariaLabel, dataHook = _a.dataHook, _b = _a.theme, theme = _b === void 0 ? 'light' : _b, onClick = _a.onClick;
    return (react_1.default.createElement("button", { onClick: onClick, className: (0, classnames_1.default)(close_button_scss_1.default[theme], className), tabIndex: 0, "aria-label": ariaLabel, "data-hook": dataHook },
        react_1.default.createElement(inline_icon_1.default, { icon: react_1.default.createElement(CloseTickIcon_1.default, null), className: close_button_scss_1.default.icon })));
};
exports.default = CloseButton;
//# sourceMappingURL=close-button.js.map